import { render, staticRenderFns } from "./mouseStandard.vue?vue&type=template&id=1580ced8"
import script from "./mouseStandard.vue?vue&type=script&lang=js"
export * from "./mouseStandard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports